/**
 * Centralized Brand Theme Configuration
 * Black / White / Metallic Gray aesthetic
 * Change these values to rebrand the entire UI instantly.
 */

export const theme = {
  colors: {
    // ── Accent (metallic) ──────────────────────────────────────────
    /** Primary accent — light metallic gray */
    primary: '#D9D9D9',
    primaryLight: '#EFEFEF',
    primaryMuted: 'rgba(217,217,217,0.08)',
    primaryBorder: 'rgba(217,217,217,0.18)',

    // ── Backgrounds ────────────────────────────────────────────────
    /** Deep black base */
    bgBase: '#000000',
    /** Dark gray surface */
    bgSurface: '#1C1C1C',
    /** Sidebar pure black */
    bgSidebar: '#000000',
    /** Secondary bg */
    bgSecondary: '#111111',

    // ── Borders ────────────────────────────────────────────────────
    border: '#2A2A2A',
    borderHover: 'rgba(255,255,255,0.15)',

    // ── Text ───────────────────────────────────────────────────────
    textPrimary: '#FFFFFF',
    textSecondary: '#A0A0A0',
    textMuted: '#888888',
    textDisabled: 'rgba(255,255,255,0.25)',

    // ── Hover highlight ────────────────────────────────────────────
    hoverHighlight: '#C0C0C0',

    // ── Status ─────────────────────────────────────────────────────
    success: '#34d399',
    successMuted: 'rgba(52,211,153,0.12)',
    warning: '#888888',
    warningMuted: 'rgba(136,136,136,0.12)',
    danger: '#f87171',
    dangerMuted: 'rgba(248,113,113,0.12)',
  },

  /** Typography */
  fonts: {
    display: "'Playfair Display', serif",
    body: "'Inter', sans-serif",
  },

  /** Border radius */
  radius: {
    sm: '6px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '9999px',
  },

  /** Spacing */
  spacing: {
    cardPadding: '20px',
    sectionGap: '32px',
  },
} as const;

export type Theme = typeof theme;
